import { Shipment } from '@domain/shipment';
import { TransportMethod } from '@domain/shipment';
import {
  ShipmentDTO,
  CreateShipmentRequestDTO,
  UpdateShipmentRequestDTO
} from '../dto/ShipmentDTO';
import { CreateShipmentRequest, UpdateShipmentRequest } from '@domain/purchasing/IShipmentRepository';
import { TransportMethodDTO } from '@infrastructure/product/dto/TransportMethodDTO';
import { PurchaseOrderItemMapper } from './PurchaseOrderItemMapper';
import { WarehouseMapper } from '@infrastructure/inventory/mappers/WarehouseMapper';

export class ShipmentMapper {
  static toModel(dto: ShipmentDTO): Shipment {
    return {
      id: dto.id,
      companyId: dto.companyId,
      name: dto.name,
      transportMethod: this.transportMethodToModel(dto.transportMethod),
      destinationWarehouse: dto.destinationWarehouse ? WarehouseMapper.toModel(dto.destinationWarehouse) : undefined,
      departureDate: new Date(dto.departureDate),
      arrivalDate: new Date(dto.arrivalDate),
      processedDate: new Date(dto.processedDate),
      purchaseOrderItems: dto.purchaseOrderItems ? dto.purchaseOrderItems.map(item => PurchaseOrderItemMapper.toModel(item)) : [],
      createdAt: new Date(dto.createdAt),
      updatedAt: new Date(dto.updatedAt),
      draft: dto.draft
    };
  }

  static createRequestToDTO(request: CreateShipmentRequest): CreateShipmentRequestDTO {
    return {
      transportMethod: this.transportMethodToDTO(request.transportMethod),
      departureDate: request.departureDate.toISOString(),
      arrivalDate: request.arrivalDate.toISOString(),
      processedDate: request.processedDate.toISOString(),
      purchaseOrderItemIds: request.purchaseOrderItemIds,
      destinationWarehouseId: request.destinationWarehouseId,
      name: request.name,
      draft: request.draft
    };
  }

  static updateRequestToDTO(request: Partial<UpdateShipmentRequest>): Partial<UpdateShipmentRequestDTO> {
    return {
      id: request.id,
      transportMethod: request.transportMethod ? this.transportMethodToDTO(request.transportMethod) : undefined,
      departureDate: request.departureDate?.toISOString(),
      arrivalDate: request.arrivalDate?.toISOString(),
      processedDate: request.processedDate?.toISOString(),
      destinationWarehouseId: request.destinationWarehouse?.id,
      name: request.name,
      draft: request.draft
    };
  }


  private static transportMethodToModel(method: TransportMethodDTO): TransportMethod {
    switch (method) {
      case TransportMethodDTO.TRUCK:
        return TransportMethod.TRUCK;
      case TransportMethodDTO.BOAT:
        return TransportMethod.BOAT;
      case TransportMethodDTO.PLANE:
        return TransportMethod.PLANE;
      case TransportMethodDTO.TRAIN:
        return TransportMethod.TRAIN;
      default:
        return TransportMethod.TRUCK;
    }
  }

  private static transportMethodToDTO(method: TransportMethod): TransportMethodDTO {
    switch (method) {
      case TransportMethod.TRUCK:
        return TransportMethodDTO.TRUCK;
      case TransportMethod.BOAT:
        return TransportMethodDTO.BOAT;
      case TransportMethod.PLANE:
        return TransportMethodDTO.PLANE;
      case TransportMethod.TRAIN:
        return TransportMethodDTO.TRAIN;
      default:
        return TransportMethodDTO.TRUCK;
    }
  }
} 